"use strict";

exports.__esModule = true;
exports.getDeductionEndtimeConfigs = getDeductionEndtimeConfigs;
var _getPoolId = require("./get-pool-id");
function getDeductionEndtimeConfigs(data) {
  const result = [];
  data.forEach(_ref => {
    let [key, value] = _ref;
    const blockNumber = key.args[0].toNumber();
    const inner = data => {
      const value = data.asValue;
      if (!value) return;
      if (value.method === 'updateClaimRewardDeductionRates' && value.section === 'incentives') {
        // eslint-disable-next-line @typescript-eslint/no-unnecessary-type-assertion
        const args = value.args;
        args.forEach(i => {
          i.forEach(item => {
            const ratio = item[1].toString();
            if (ratio === '0') {
              result.push([(0, _getPoolId.getPoolId)(item[0]), blockNumber]);
            }
          });
        });
      }
      if (value.method === 'batchAll' && value.section === 'utility') {
        // eslint-disable-next-line @typescript-eslint/no-unnecessary-type-assertion
        value.args[0].forEach(item => inner(item));
      }
    };
    value.forEach(item => inner(item.unwrapOrDefault().call));
  });
  return Object.fromEntries(result);
}